import { useState, useEffect } from 'react';
import axios from 'axios';

const useFetchLostPets = () => {
    const [lostPets, setLostPets] = useState([]);
    const [error, setError] = useState(null);
    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';

    useEffect(() => {
        const fetchLostPets = async () => {
            try {
                const response = await axios.get(`${baseUrl}/api/pets/lost`);
                console.log('API Response for Lost Pets:', response.data); // Log the entire API response

                const processedLostPets = response.data.map(pet => {
                    console.log('Processing pet:', pet); // Log the entire pet object

                    if (!pet.lostInfo) {
                        console.warn('Missing lostInfo for pet:', pet);
                    }

                    // Extract the latest lostInfo entry with valid lastSeenLocation
                    const latestLostInfo = pet.lostInfo?.reduce((latest, current) => {
                        if (current.lastSeenLocation?.coordinates?.length) {
                            if (!latest || new Date(current.lastSeenDate) > new Date(latest.lastSeenDate)) {
                                return current;
                            }
                        }
                        return latest;
                    }, null); // Start with null to handle empty arrays

                    console.log('LostInfo array:', pet.lostInfo);
                    console.log('Selected latestLostInfo:', latestLostInfo);

                    return {
                        id: pet._id,
                        name: pet.name,
                        breed: pet.breed,
                        location: latestLostInfo?.lastSeenLocation?.coordinates ? {
                            lat: latestLostInfo.lastSeenLocation.coordinates[1],
                            lng: latestLostInfo.lastSeenLocation.coordinates[0],
                        } : null,
                        dateLost: latestLostInfo?.lastSeenDate || null, // Ensure dateLost is null if no valid entry
                        lostInfo: latestLostInfo,
                        petType: pet.petType || 'Unknown',
                        status: pet.status || 'Unknown',
                        images: pet.images || [],
                        owner: pet.owner,
                        organizationId: pet.organizationId, // Include organizationId if available
                    };
                }); // Remove filtering to include all pets
                setLostPets(processedLostPets);
            } catch (error) {
                setError(error.message);
            }
        };

        fetchLostPets();
    }, []);

    return { lostPets, error };
};

export default useFetchLostPets;